import { Group } from 'three';
import { ComponentInteractionType, SceneComponent } from '@/_models/virtualStaging/Scene.component';
import { LoadingState } from '@/_models/virtualStaging/VSObject';
import { Inputs, Outputs } from '@/_models/virtualStaging/HTMLMesh/component/types';

export class AbstractHTMLMesh extends SceneComponent {
  public root: any = null;

  public pivot: any = null;

  public controllers: Group[];

  public controllerL: Group;

  public controllerR: Group;

  public gamepadL;

  public gamepadR;

  // Created to simulate click events on controller
  public gamepadButtonActive: boolean;

  public gamepadButtonSecondaryActive: boolean;

  public gamepadThumbStickYActive: boolean;

  public triggerActive: boolean;

  inputs: Inputs = {
    html: null,
    visible: false,
    scale: 1,
  };

  outputs: Outputs = {
    loadingState: LoadingState.Idle,
  };

  events = {
    [ComponentInteractionType.CLICK]: true,
    [ComponentInteractionType.HOVER]: true,
    [ComponentInteractionType.DRAG]: false,
  };

  declare context: any;

  protected initRoot() {
    const THREE = this.context.three;
    this.root = new THREE.Object3D();
    this.root.visible = this.inputs.visible;
    this.root.scale.set(this.inputs.scale, this.inputs.scale, this.inputs.scale);
    this.pivot = new THREE.Object3D();
    this.root.add(this.pivot);
    this.outputs.objectRoot = this.root;
    this.outputs.collider = this.root;
    this.outputs.loadingState = LoadingState.Loading;
  }

  getXRController() {
    const { xr } = this.context.renderer;

    this.controllers = [xr.getController(0), xr.getController(1)];

    this.controllers.forEach((controller) => {
      controller.addEventListener('connected', (event) => {
        const inputSource = event.data;
        const { handedness } = inputSource;
        if (handedness === 'left') {
          this.controllerL = controller;
          this.gamepadL = inputSource.gamepad;
        } else if (handedness === 'right') {
          this.controllerR = controller;
          this.gamepadR = inputSource.gamepad;
        }
      });
    });
  }

  onVisibleChange() {}

  setVisible(visible) {
    this.inputs.visible = visible;
    if (this.onVisibleChange) this.onVisibleChange();
  }

  onInputsUpdated(previousInputs: this['inputs']) {
    this.root.visible = this.inputs.visible;
  }

  onDestroy() {}
}
